import { getChartResolution } from "../../constants/chart/resolutions";

/** Library interval strings that may differ from our ids. */
const LIBRARY_ALIASES: Record<string, string> = { D: "1D", W: "1W", M: "1M" };

export type ReadyResolution = { adopt: string } | { push: string } | null;

/**
 * Reconcile the chart's interval with React state once the library is ready.
 *
 * The library renders its header — interval menu included — before
 * `onChartReady`, and our `onIntervalChanged` subscription only exists after
 * it. A pick made in that window changes the chart but never reaches React,
 * so the two disagree at ready time. React state can only change through that
 * subscription and the widget is built with `interval: resolution`, so a
 * disagreement is the user's early pick: adopt it. Push our value only when
 * the library holds an interval the backend does not serve.
 */
export const reconcileReadyResolution = (chartNow: string, wanted: string): ReadyResolution => {
  const current = LIBRARY_ALIASES[chartNow] ?? chartNow;
  if (current === wanted) return null;
  if (getChartResolution(current)) return { adopt: current };
  return { push: wanted };
};
